import React, {Fragment} from 'react';
import Select from './../Select';
import isEqual from 'lodash-es/isEqual';
import {set, get} from '../../../utils/dotutils';
import PropTypes from 'prop-types';
import CheckBoxGroup from "../CheckBoxGroup";
import CashPayment from "./CashPayment";
import VoucherPayment from "./VoucherPayment";
import SwapPayment from "./SwapPayment";
import BankcardPayment from "./BankcardPayment";
import AdvanceTransferPayment from "./AdvanceTransferPayment";
import CodPayment from "./CodPayment";
import TransferPayment from "./TransferPayment";
import debounce from "../../../utils/debounce";
import {hufRound} from "../../../utils/other";
import Button from "../Button";
import Portal from "../../layout/Portal";

const OptionsTemplate = (props) => {
    const {optionIndex, checkbox, option} = props;
    let extras = {
        "SwapPayment": SwapPayment,
        "VoucherPayment": VoucherPayment,
        "Cash": CashPayment,
        "Bankcard": BankcardPayment,
        "AdvanceTransfer": AdvanceTransferPayment,
        "Cod": CodPayment,
        "Transfer": TransferPayment,
    };
    let Provider = props.checked && extras[option.serviceprovider_type];
    let actionComponent;
    if (props.buttonStyled) {
        actionComponent = <Button
            block={true}
            color={props.checkbox.props.checked ? "primary" : "default"}
            onClick={props.checkbox.props.saveChanges}
        >
            {props.checkbox.props.label}
        </Button>;
    } else {
        actionComponent = checkbox;
    }
    if (props.separatedStyle) {
        return <Fragment key={optionIndex}>
            <Portal portalId={"payment_options_" + props.paymentOptionsPortalId}>
                {actionComponent}
            </Portal>
            <Portal portalId={"payment_providers_" + props.paymentOptionsPortalId}>
                {Provider && <Fragment>
                    <label className="control-label">
                        {props.checkbox.props.label}
                    </label>
                    <Provider {...props} setFieldValue={props.setFieldValue}/>
                </Fragment>}
            </Portal>
        </Fragment>
    }
    return <Fragment key={optionIndex}>
        {actionComponent}
        {Provider && <Provider {...props} setFieldValue={props.setFieldValue}/>}
    </Fragment>
};

class PaymentsControl extends React.Component {

    static propTypes = {
        required: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
        value: PropTypes.any,
        fields: PropTypes.array,
        layout: PropTypes.any,
        rounding: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.instanceOf(null), PropTypes.instanceOf(undefined)]),
        overpay: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.instanceOf(null), PropTypes.instanceOf(undefined)]),
        cost: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.instanceOf(null), PropTypes.instanceOf(undefined)]),
        total: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.instanceOf(null), PropTypes.instanceOf(undefined)]),
        providerTheme: PropTypes.oneOf(["select","radio"]),
    }

    constructor(props) {
        super(props);
        this.state = {
            value: JSON.parse(JSON.stringify(this.props.value))
        }
        this.saveChanges = debounce((name, v) => {
            this.props.saveChanges && this.props.saveChanges(name, v);
        }, 300);
        this.id = new Date().getTime();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!isEqual(this.props.value, prevProps.value)) {
            this.setState({
                value: JSON.parse(JSON.stringify(this.props.value))
            });
        }
    }

    setFieldValue = async (field, value) => {
        let oldValue = JSON.parse(JSON.stringify(get(this.state.value, field)));
        if (!isEqual(oldValue, value)) {
            const v = JSON.parse(JSON.stringify(Array.isArray(this.state.value) ? [...this.state.value] : (this.state.value ? {...this.state.value} : [])));
            set(v, field, value);
            this.setState({
                value: v,
            });
            this.saveChanges(this.props.name || 'payment', v);
        }
    }

    render() {
        const name = this.props.name || "payment";
        const theme = this.props.providerTheme || "select";
        const values = this.state.value || [];
        const cost = parseFloat(this.props.cost || 0);
        const rounding = parseFloat(this.props.rounding || 0);
        const overpay = parseFloat(this.props.overpay || 0);
        const total = parseFloat(this.props.total || 0);
        if (theme === "select") {
            return <div className="col-md-12">
                <Select
                    required={this.props.required === true || (Array.isArray(this.props.required) && this.props.required.indexOf("serviceprovider_type") !== -1)}
                    name={name + "serviceprovider_type"}
                    component="PaymentServiceProvider"
                    storeType="local"
                    labelKey="methodname"
                    valueKey="id"
                    isMulti={true}
                    objectValue={false}
                    options={this.props.availableProviders}
                    value={values}
                    saveChanges={(field, value) => {
                        const options = (value || []);
                        value = (this.props.value || []).filter((v) => options.indexOf(v.serviceprovider_type) !== -1);
                        this.props.saveChanges(name, value);
                    }}
                    label="Fizetés módja"
                />
            </div>;
        } else if(theme === "radio") {
            let providers = this.props.availableProviders.map((option) => {
                const serviceprovider_type = option.id;
                let data = values.find((value) => value.serviceprovider_type === serviceprovider_type);
                if (data) {
                    return {...data, methodname: option.methodname};
                }
                data = {
                    serviceprovider_type,
                    methodname: option.methodname,
                };
                switch (serviceprovider_type) {
                    case "Cash":
                        let value = Math.max(0, total - (cost + rounding) - (overpay > 0 ? overpay : 0));
                        data.amount = hufRound(parseFloat(value || "0"));
                        break;
                    case "Bankcard":
                        data.amount = Math.round(Math.max(0, total - (cost + rounding) - (overpay > 0 ? overpay : 0)));
                        break;
                    case "VoucherPayment":
                        data.vouchers = [];
                        data.amount = 0;
                        break;
                    case "SwapPayment":
                        data.purchaseitems = [];
                        data.amount = 0;
                        break;
                }
                return data;
            });
            return <div className="col-md-12">
                {this.props.separatedStyle && <div className="payment-options" id={"payment_options_" + this.id} />}
                {this.props.separatedStyle && <div className="payment-providers" id={"payment_providers_" + this.id} />}
                <CheckBoxGroup
                    {...this.props}
                    setFieldValue={this.setFieldValue}
                    paymentOptionsPortalId={this.id}
                    required={this.props.required}
                    name={name}
                    labelKey="methodname"
                    valueKey="serviceprovider_type"
                    storeType="local"
                    options={providers}
                    value={values}
                    isMulti={true}
                    total={total}
                    cost={cost}
                    rounding={rounding}
                    disableOption={({value, optionIndex}) => !!value.length && (total === cost + rounding || total < cost + overpay) && optionIndex === -1}
                    optionsTemplate={OptionsTemplate}
                    saveChanges={(name, value) => {
                        this.props.saveChanges(name, value);
                    }}
                    label={this.props.label !== undefined ? this.props.label : "Fizetés módja"}
                />
            </div>
        }
    }

}

export default PaymentsControl;